import { StyleSheet } from 'aphrodite';
import { borderColor, brandPrimary, error, navigation } from '../../../../../web/styles/colors';
import { CssSelectors, Layouts } from '../../../../../web/styles/styles';

const recentActivityCardMargin = 10;

export const TableInitialsColumnWidth = 150;
export const TableCellBorder = '1px solid #D8D8D8';

export const styleSheet = StyleSheet.create({
	cell: {
		borderBottom: TableCellBorder,
		padding: '10px 5px 10px 0',
	},
	checkboxContent: {
		minWidth: 150,
		paddingLeft: 12,
	},
	container: {
		...Layouts.verticalStack(16),
		fontSize: 12,
		width: '100%',
	},
	description: {
		fontStyle: 'italic',
	},
	fileSourcePath: {
		wordWrap: 'break-word',
	},
	radio: {
		marginBottom: 5,
	},
	radioText: {},
	recentActivityCard: {
		background: '#FFFFFF',
		border: '1px solid #D3DBDE',
		borderRadius: 10,
		boxShadow: '0 0 6px 0 rgba(139,139,139,0.10)',
		boxSizing: 'border-box',
		flexShrink: 0,
		height: 256,
		marginLeft: recentActivityCardMargin,
		marginTop: recentActivityCardMargin,
		overflow: 'auto',
		padding: '30px 20px',
		width: 216,
	},
	recentActivityCards: {
		overflow: 'hidden',
	},
	recentActivityCardsContent: {
		alignItems: 'flex-start',
		display: 'flex',
		flexWrap: 'wrap',
		margin: `-${recentActivityCardMargin}px 0 0 -${recentActivityCardMargin}px`,
	},
	reloadAutoComplete: {
		marginTop: 5,
	},
	reloadOptions: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		paddingTop: 20,
		...CssSelectors.allChildren({
			marginBottom: 5,
			minWidth: '50%',
		}),
	},
	resyncBody: {
		paddingTop: 20,
		position: 'relative',
	},
	resyncContainer: {
		display: 'flex',
		flexDirection: 'row',
		minHeight: 200,
		width: 500,
		...CssSelectors.allChildren({
			padding: 10,
		}),
		...CssSelectors.allChildren(
			{
				borderRight: `1px solid ${borderColor}`,
				maxWidth: 160,
				minWidth: 160,
			},
			':first-child'
		),
		...CssSelectors.allChildren(
			{
				flexGrow: 1,
			},
			':last-child'
		),
	},
	resyncHeader: {
		color: brandPrimary,
	},
	resyncModal: {
		...CssSelectors.allDescendants(
			{
				margin: '20px auto 0',
			},
			'.resync-cta'
		),
		...CssSelectors.allDescendants(
			{
				color: navigation,
				fontSize: 14,
				margin: 0,
			},
			'p:not(.warning)'
		),
	},
	tableContainer: {
		alignItems: 'stretch',
		border: '1px solid #D3DBDE',
		borderRadius: 10,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		boxSizing: 'border-box',
		display: 'flex',
		marginBottom: '1.5rem',
		padding: '20px 30px',
		overflowX: 'auto',
		width: '100%',
		'@media (max-width: 1400px)': {
			padding: '15px 20px', // Reduce padding for ThinkPad screens
		},
	},
	tableHeader: {
		background: '#fff',
	},
	tableHeaderCell: {
		borderBottom: TableCellBorder,
		color: '#AAAAAA',
		fontSize: 11,
		letterSpacing: '1.1px',
		paddingBottom: 20,
		textTransform: 'uppercase',
		'@media (max-width: 1400px)': {
			fontSize: 10,
			minWidth: 110,
		},
	},
	tableHeaderInitialsHeader: {
		minWidth: TableInitialsColumnWidth,
		whiteSpace: 'nowrap',
		width: TableInitialsColumnWidth,
		'@media (max-width: 1400px)': {
			minWidth: 110,
			width: 110,
		},
	},
	warningText: {
		color: error,
		fontSize: 12,
		margin: '15px 0 0',
	},
});
